import { LayoutDashboard, Radio, Wallet, Newspaper, History, Bot, ChevronLeft, Zap, KeyRound, ShieldCheck, UserCog, Flame, FlaskConical, ScanLine } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { id: "overview", label: "Genel Bakış", icon: LayoutDashboard },
  { id: "bot", label: "Bot Yönetimi", icon: Bot },
  { id: "futures", label: "Kaldıraçlı Botlar", icon: Zap },
  { id: "signals", label: "Sinyaller", icon: Radio },
  { id: "positions", label: "Pozisyonlar", icon: Wallet },
  { id: "livetrades", label: "Canlı İşlemler", icon: Flame },
  { id: "news", label: "Haber & Analiz", icon: Newspaper },
  { id: "history", label: "İşlem Geçmişi", icon: History },
  { id: "simulations", label: "Simülasyonlar", icon: FlaskConical },
  { id: "reconciliation", label: "Dolum Kontrolü", icon: ScanLine },
  { id: "risk-profiles", label: "Risk Profilleri", icon: ShieldCheck },
  { id: "api", label: "API Ayarları", icon: KeyRound },
  { id: "profile", label: "Profil", icon: UserCog },
];

export const NAV_ITEMS = NAV;

export const Sidebar = ({ active, onNavigate, collapsed, onToggle, binanceConnected, isAdmin }) => {
  const items = isAdmin ? [...NAV, { id: "admin", label: "Admin Paneli", icon: ShieldCheck }] : NAV;
  return (
    <aside
      data-testid="sidebar"
      className={cn(
        "sticky top-0 h-screen flex-shrink-0 border-r border-[var(--border)] bg-[var(--app-bg)] hidden md:flex flex-col transition-[width] duration-300 z-20",
        collapsed ? "w-[68px]" : "w-[236px]"
      )}
    >
      <div className="h-16 flex items-center gap-3 px-4 border-b border-[var(--border)]">
        <div className="h-9 w-9 rounded-md bg-[var(--pos)] flex items-center justify-center flex-shrink-0">
          <Bot className="h-5 w-5 text-black" strokeWidth={2.4} />
        </div>
        {!collapsed && (
          <div className="leading-tight">
            <div className="font-head font-black text-[15px] tracking-tight">CRYPTOSENSE</div>
            <div className="text-[10px] text-[var(--accent)] tracking-[0.2em]">AI TRADING DESK</div>
          </div>
        )}
      </div>

      <nav className="flex-1 min-h-0 overflow-y-auto py-4 flex flex-col gap-1 px-3">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.id;
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => onNavigate(item.id)}
              className={cn(
                "flex items-center gap-3 rounded-md px-3 h-11 shrink-0 text-sm transition-colors duration-150 group",
                isActive
                  ? "bg-[#00FFA3]/10 text-[var(--pos)] border border-[#00FFA3]/30"
                  : "text-[var(--text-dim)] hover:bg-[var(--surface-hover)] hover:text-[var(--text-primary)] border border-transparent"
              )}
            >
              <Icon className="h-[18px] w-[18px] flex-shrink-0" strokeWidth={isActive ? 2.4 : 2} />
              {!collapsed && <span className="truncate">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      <div className="p-3 border-t border-[var(--border)]">
        <div className={cn("flex items-center gap-2 rounded-md px-3 h-10 text-xs",
          binanceConnected ? "bg-[#00FFA3]/10 text-[var(--pos)]" : "bg-[var(--surface-hover)] text-[var(--text-dim)]")}>
          <span className={cn("h-2 w-2 rounded-full flex-shrink-0", binanceConnected ? "bg-[var(--pos)] animate-pulse" : "bg-[var(--text-faint)]")} />
          {!collapsed && <span className="truncate">{binanceConnected ? "Gate.io Bağlı" : "Gate.io Bağlı Değil"}</span>}
        </div>
        <button
          data-testid="sidebar-toggle"
          onClick={onToggle}
          className="mt-2 w-full flex items-center justify-center h-9 rounded-md text-[var(--text-dim)] hover:bg-[var(--surface-hover)] hover:text-[var(--text-primary)] transition-colors"
        >
          <ChevronLeft className={cn("h-4 w-4 transition-transform", collapsed && "rotate-180")} />
        </button>
      </div>
    </aside>
  );
};
